import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import Form from './Form';
import Notification from '@deporvillage/notification-component';
import { I18n, I18nContext } from '@deporvillage/utils-library-component';

import styles from './ForgotPassword.module.scss';

/* istanbul ignore next */
const scrollToBottom = (elem) =>
    elem.scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'end' });

const ForgotPasswordSuccess = ({ email, onBack, showBackToLogin }) => {
    const { translate } = useContext(I18nContext);
    return (
        <>
            <p
                className={styles['success-badge']}
                dangerouslySetInnerHTML={{
                    __html: translate('forgotpassword.forgotpassword_popup.success', {
                        email: email,
                    }),
                }}
            />
            <div
                className={styles['success-instruccions']}
                dangerouslySetInnerHTML={{
                    __html: translate('forgotpassword.forgotpassword_popup.success_instruccions'),
                }}
            />
            {!showBackToLogin ? null :
                <button onClick={() => onBack && onBack()} className={styles['button']}>
                    <I18n>forgotpassword.forgotpassword_popup.back_to_login</I18n>
                </button>
            }
        </>
    );
};

ForgotPasswordSuccess.propTypes = {
    email: PropTypes.string,
    onBack: PropTypes.func,
    showBackToLogin: PropTypes.bool,
};

const ForgotPassword = ({ customerData, onChange, onForgotPassword, onBack, error, success, showBackToLogin }) => {
    const { email } = customerData;

    const forgotPasswordError = React.useRef(null);

    const handleOnChange = (input) => onChange && onChange(input, customerData);

    const handleOnForgotPassword = (e) => {
        e.preventDefault();
        onForgotPassword && onForgotPassword(customerData);
    };

    const handleOnBack = () => onBack && onBack();

    React.useEffect(() => {
        if (error && forgotPasswordError.current) {
            scrollToBottom(forgotPasswordError.current);
        }
    }, [error]);

    return (
        <div className={styles['forgotpassword-component']}>
            <div className={styles['title-form']}>
                <h1>
                    <I18n>forgotpassword.forgotpassword_popup.title.forgotpassword</I18n>
                </h1>
            </div>
            {success ? (
                <ForgotPasswordSuccess onBack={handleOnBack} email={email?.value} showBackToLogin={showBackToLogin} />
            ) : (
                <>
                    <form
                        autoComplete={'off'}
                        className={styles['form-component']}
                        id={'forgotpassword-form'}
                    >
                        <p>
                            <I18n>forgotpassword.forgotpassword_popup.how</I18n>
                        </p>
                        <Form
                            {...email}
                            onChange={(value) => handleOnChange({ ...email, value })}
                        />
                        <button onClick={handleOnForgotPassword} className={styles['button']}>
                            <I18n>forgotpassword.forgotpassword_popup.forgotpassword</I18n>
                        </button>

                        <div className={styles['required']}>
                            * <I18n>form.generic.required_fields</I18n>
                        </div>
                    </form>
                    {error ? (
                        <div ref={forgotPasswordError} className={styles['forgotpassword-error']}>
                            <Notification
                                message={<I18n>forgotpassword.forgotpassword_popup.error</I18n>}
                                type='error'
                            />
                        </div>
                    ) : null}
                </>
            )}
        </div>
    );
};

ForgotPassword.propTypes = {
    customerData: PropTypes.shape({
        email: PropTypes.shape({
            id: PropTypes.string,
            type: PropTypes.string,
            label: PropTypes.string,
            value: PropTypes.string,
            error: PropTypes.string,
            validate: PropTypes.array,
        }),
    }),
    onForgotPassword: PropTypes.func,
    onChange: PropTypes.func,
    onBack: PropTypes.func,
    error: PropTypes.bool,
    success: PropTypes.bool,
    showBackToLogin: PropTypes.bool,
};

export default ForgotPassword;
